import React from "react";
import { ArrowRight, FileText, Package, ShoppingBag, Users } from "lucide-react";

const QuickStats = ({ navigation, data = {} }) => {
  const stats = [
    {
      title: "Invoices",
      value: data.totalInvoices,
      subtitle: "Total Invoices",
      icon: FileText,
      route: "Invoices",
      tone: "blue",
    },
    {
      title: "Purchases",
      value: data.totalPurchases,
      subtitle: "Total Purchases",
      icon: ShoppingBag,
      route: "purchaseOrder",
      tone: "green",
    },
    {
      title: "Items",
      value: data.totalItems,
      subtitle: "Total Items",
      icon: Package,
      route: "items",
      tone: "orange",
    },
    {
      title: "Customers",
      value: data.totalCustomers,
      subtitle: "Total Customers",
      icon: Users,
      route: "Customers",
      tone: "violet",
    },
  ];

  return (
    <div className="zarp-stats-grid">
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <button key={stat.title} className="zarp-stat-card" onClick={() => navigation.navigate(stat.route)}>
            <span className={`zarp-stat-icon ${stat.tone}`}>
              <Icon size={22} />
            </span>
            <span className="zarp-stat-copy">
              <small>{stat.title}</small>
              <strong>{Number(stat.value) || 0}</strong>
              <em>{stat.subtitle}</em>
            </span>
            <span className="zarp-stat-link">
              View All
              <ArrowRight size={15} />
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default QuickStats;
